class Monitoring.Views.SocialContents.SocialContentGoogleSearchView extends Backbone.View
  template: JST['backbone/templates/monitoring/social_contents_v2/social_content_google.jst.ejs']

  initialize: (options = {}) ->
    @model = options.model

  render: ->
    @$el.html @template
      name: @model.getValue 'type'
    this
